import { RoundCheckButton } from "@/components/RoundCheckButton";

type TodoItemProps = {
  id: string;
  title: string;
  checked: boolean;
  quantity?: string | null;
  onToggle: (id: string, checked: boolean) => void;
  onSelect?: (id: string) => void;
};

export const TodoItem = ({
  id,
  title,
  checked,
  quantity,
  onToggle,
  onSelect,
}: TodoItemProps) => {
  return (
    <div className="flex h-[4.25rem] items-center gap-3 pl-2">
      <RoundCheckButton
        checked={checked}
        onClick={() => onToggle(id, checked)}
      />
      <button
        type="button"
        className={`min-w-0 flex-1 text-left ${
          checked ? "text-muted-foreground line-through" : "text-foreground"
        }`}
        onClick={() => onSelect?.(id)}
      >
        <p className="truncate text-base">{title}</p>
        {quantity && (
          <span className="text-sm text-muted-foreground">{quantity}</span>
        )}
      </button>
    </div>
  );
};
